"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Row;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Row({
  index,
  style,
  styles,
  rowData,
  isExpanded,
  isRowLoaded,
  collapsedColumnDefs,
  columns,
  cachedColumnStyles,
  tooltipRef,
  intl,
  getCellRendererFn,
  expansion,
  setRowHeight
}) {
  const rowRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (rowRef.current.clientHeight) {
      setRowHeight(index, rowRef.current.clientHeight);
    }
  }, [rowRef?.current?.clientHeight]);
  const _createColumn = ({
    column: {
      cellRenderer,
      className,
      columnData,
      dataKey
    },
    columnIndex,
    rowData,
    rowIndex
  }) => cellRenderer({
    style: cachedColumnStyles[columnIndex],
    cellData: rowData.get(dataKey),
    tooltipRef,
    className,
    columnData,
    columnIndex,
    dataKey,
    rowData,
    rowIndex
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: isExpanded ? styles.expanded : index % 2 === 0 ? styles.even : styles.odd,
    role: "row",
    ref: rowRef,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.content
  }, isRowLoaded ? (0, _map.default)(columns).call(columns, (column, i) => _createColumn({
    column: column.props,
    columnIndex: i,
    rowData,
    rowIndex: index
  })) : null), isExpanded ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.expansion
  }, Boolean(collapsedColumnDefs.length) ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.collapsed_columns
  }, (0, _map.default)(collapsedColumnDefs).call(collapsedColumnDefs, col => /*#__PURE__*/_react.default.createElement("div", {
    key: `collapsed_col_${col.property}`,
    className: styles.column_cell
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.label
  }, intl.formatMessage({
    id: col.labelId
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.colon
  }, ":"), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.text
  }, getCellRendererFn(col)({
    cellData: rowData.get(col.property),
    rowData
  }))))) : null, typeof rendererFn === 'function' && expansion(index, rowData)) : null);
}